import { Heading, Text } from '@chakra-ui/react';
import type { HeadingProps } from '@chakra-ui/react';
import { SPLIT_MARK } from '../lib/splitMarker';

interface SplitHeadingProps extends HeadingProps {
  /** Heading text; text before a `§` marker renders bold, text after it regular. */
  text: string;
  regularWeight?: number;
}

/**
 * Several Figma headings mix Inter 700 + Inter 400 within one line (e.g.
 * "**Music for your business —** automated, compliant…"). The text carries a
 * single `§` marker at the weight boundary; the part before it inherits the
 * Heading's (bold) weight, the part after renders at `regularWeight`.
 */
export function SplitHeading({ text, regularWeight = 400, ...rest }: SplitHeadingProps) {
  const idx = text.indexOf(SPLIT_MARK);
  if (idx === -1) {
    return <Heading {...rest}>{text}</Heading>;
  }
  return (
    <Heading {...rest}>
      {text.slice(0, idx)}
      <Text as="span" fontWeight={regularWeight}>
        {text.slice(idx + SPLIT_MARK.length)}
      </Text>
    </Heading>
  );
}
